import { Routines } from '@heidi/design-system/icons';
import { cn } from '@heidi/utils';
import { useQueryClient } from '@tanstack/react-query';
import type { LucideIcon } from 'lucide-react';
import { useCallback } from 'react';
import { WORKFLOW_KEYS } from '../../../contracts/keys';
import {
  RoutineOutcomeRow,
  type RoutineOutcomeAction,
} from '../../inline-approval/routine-outcome-row';

interface WorkflowCreatedCardProps {
  title: string;
  action: RoutineOutcomeAction;
  meta?: string;
  /** When omitted, the card is confirmation-only (no open action). */
  onOpen?: () => void;
  className?: string;
}

/** Inline card after create/update/run — opens the routine when ``onOpen`` is set. */
export const WorkflowCreatedCard = ({
  title,
  action,
  meta,
  onOpen,
  className,
}: WorkflowCreatedCardProps): JSX.Element => {
  const qc = useQueryClient();

  const handleOpen = useCallback(() => {
    if (!onOpen) return;
    void qc.invalidateQueries({ queryKey: WORKFLOW_KEYS.all });
    onOpen();
  }, [qc, onOpen]);

  return (
    <RoutineOutcomeRow
      action={action}
      name={title}
      meta={meta}
      Icon={Routines as LucideIcon}
      onOpen={onOpen ? handleOpen : undefined}
      className={cn(className)}
    />
  );
};
